export default __webpack_public_path__ + "static/media/MC.11bf2695.svg";